import { render, staticRenderFns } from "./sponsorship.vue?vue&type=template&id=35e2b10c&scoped=true&"
import script from "./sponsorship.vue?vue&type=script&lang=ts&"
export * from "./sponsorship.vue?vue&type=script&lang=ts&"
import style0 from "./sponsorship.vue?vue&type=style&index=0&id=35e2b10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e2b10c",
  null
  
)

export default component.exports